import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-info-bloc-autopartage',
  templateUrl: './info-bloc-autopartage.component.html',
  styleUrls: ['./info-bloc-autopartage.component.scss']
})
export class InfoBlocAutopartageComponent implements OnInit {

  constructor() {this.getUrl()}


  isMontDesAvaloirs: boolean = false
  isMamSncf: boolean = false

  ngOnInit() {
  }


  getUrl(){
    let host = location.host
    if(host === `mont-des-avaloirs.clem.mobi` ||  host === `www.mont-des-avaloirs.clem.mobi`){
      this.isMontDesAvaloirs = true
    }else {
      this.isMontDesAvaloirs = false
    }
    if(host === `mam.clem.mobi` || host === `www.mam.clem.mobi`){
      this.isMamSncf = true
    }else {
      this.isMamSncf = false
    }
  }

}
